export default {
  nav: {
    platform: '平台',
    aiAgents: 'AI 代理',
    features: '功能',
    developers: '開發者',
    roadmap: '路線圖',
    launchApp: '啟動應用',
    lightMode: '白天模式',
    darkMode: '夜晚模式',
  },
  hero: {
    badge: '主網直播中',
    title1: 'AI 原生',
    title2: '交易基礎設施',
    subtitle:
      '全鏈上永續合約、AI 執行代理、預測市場及即時流動性，全面整合於單一平台。',
    startTrading: '開始交易',
    launchAgent: '啟動代理',
    apiDocs: 'API 文件',
    volume24h: '24H 成交量',
    activeTraders: '活躍交易者',
    uptime: '上線時間',
    terminalName: 'zhisu-terminal',
    live: '直播中',
    oi: '未平倉合約',
    funding: '資金費率',
    spread: '價差',
    aiActive: 'AI 運行中',
    liveTrades: '即時交易',
    realtime: '即時',
    long: '做多',
    short: '做空',
  },
  metrics: {
    realtimeMetrics: '即時指標',
    platformGlance: '平台概覽',
    volume24h: '24H 成交量',
    openInterest: '未平倉合約',
    activeTraders: '活躍交易者',
    aiExecutions: 'AI 執行次數',
    fundingRate: '資金費率',
    totalTrades: '總交易次數',
  },
  agents: {
    autonomousIntelligence: '自主智能',
    aiTradingAgents: 'AI 交易代理',
    description:
      '部署自主 AI 代理，全天候 24/7 以機器學習策略進行交易。每個代理完全透明、可審計且經過實戰驗證。',
    pnl30d: '盈虧 (30日)',
    winRate: '勝率',
    trades24h: '交易次數 (24h)',
    avgHold: '平均持倉時間',
    risk: '風險',
    exploreAll: '查看全部代理',
  },
  features: {
    productSuite: '產品套件',
    everythingNeed: '交易所需的一切',
    description:
      '從永續合約到 AI 執行，完整的交易基礎設施，全鏈上且完全透明。',
    learnMore: '了解更多',
  },
  dev: {
    developerFirst: '開發者優先',
    builtForBuilders: '為構建者打造',
    description:
      '完整的 API 存取、SDK 及即時 WebSocket 串流。數分鐘內即可建構交易機器人、代理和自訂策略。',
    sdksAndApis: 'SDK 與 API',
    restApi: 'REST API',
    websocket: 'WebSocket',
    pythonSdk: 'Python SDK',
    agentSdk: 'Agent SDK',
    tradingSdk: '交易 SDK',
    viewDocs: '查看完整文件',
  },
  arch: {
    systemDesign: '系統架構',
    dualEngine: '雙引擎架構',
    description:
      '四個專業引擎協同運作，實現 100ms 內執行及機構級可靠性。',
    aiEngine: 'AI 引擎',
    liquidityEngine: '流動性引擎',
    executionEngine: '執行引擎',
    riskEngine: '風險引擎',
    latency: '延遲',
    models: '模型數',
    depth: '深度',
    pairs: '交易對',
    tps: 'TPS',
    uptime: '上線率',
    coverage: '覆蓋率',
    alerts: '警報',
  },
  roadmap: {
    ourJourney: '我們的旅程',
    roadmap2026: '2026 路線圖',
    description:
      '一步一步建構 AI 原生交易基礎設施的未來。',
    completed: '已完成',
    inProgress: '進行中',
    upcoming: '即將上線',
  },
  footer: {
    product: '產品',
    developers: '開發者',
    company: '公司',
    legal: '法律',
    description:
      '首選 AI 原生交易基礎設施，支持鏈上永續合約、預測市場及自主執行。',
    allRights: '版權所有。',
    systemsOperational: '所有系統正常',
  },
  content: {
    agents: {
      scalper: {
        name: 'AI 超短線交易',
        description:
          '高頻動量交易，在劇烈波動時以亞秒級速度執行',
      },
      'funding-arb': {
        name: '資金費率套利機器人',
        description:
          '自動追蹤各永續合約交易所的資金費率進行套利',
      },
      'meme-hunter': {
        name: 'Meme 獵手',
        description:
          '社群情緒分析，於熱門 token 行情中提前入場',
      },
      'prediction-ai': {
        name: '預測 AI',
        description:
          '機器學習模型，以 71% 的準確率預測市場方向',
      },
      'whale-tracker': {
        name: '鯨魚追蹤器',
        description:
          '鏈上分析，追蹤聰明資金流動及鯨魚錢包',
      },
    },
    features: {
      perpetual: {
        title: '永續合約交易',
        description:
          '全鏈上永續期貨，最高 50 倍槓桿，零滑點',
      },
      'ai-execution': {
        title: 'AI 執行',
        description:
          'AI 驅動訂單路由，跨市場最佳入場時機',
      },
      prediction: {
        title: '預測市場',
        description:
          '去中心化預測市場，加密結果即時結算',
      },
      'copy-trading': {
        title: '跟單交易',
        description:
          '一鍵追蹤頂尖 AI 代理和專業交易者',
      },
      hyperevm: {
        title: 'HyperEVM',
        description:
          '跨鏈擴展，支持以太坊、Solana、Arbitrum 及 Base',
      },
      vault: {
        title: '策略金庫',
        description:
          '內建風險管理的自動化收益策略',
      },
    },
    engines: {
      'ai-engine': {
        name: 'AI 引擎',
        description:
          '神經網絡驅動的訊號產生、模式識別和預測建模',
      },
      'liquidity-engine': {
        name: '流動性引擎',
        description:
          '深度訂單簿聚合和跨鏈流動性路由',
      },
      'execution-engine': {
        name: '執行引擎',
        description:
          '100ms 內下單執行，含 MEV 保護和最佳路由',
      },
      'risk-engine': {
        name: '風險引擎',
        description:
          '即時持倉監控、清算保護和投資組合對沖',
      },
    },
    roadmap: {
      q1: {
        title: 'Beta 上線',
        items: [
          'AI Agents v1，5 種策略',
          '永續合約主網上線',
          'WebSocket 即時 API',
          '跨鏈橋接整合',
        ],
      },
      q2: {
        title: '主網擴展',
        items: [
          '預測市場上線',
          'Python & TypeScript SDK',
          '行動交易 App Beta',
          '機構級 API 存取',
        ],
      },
      q3: {
        title: '生態系統擴展',
        items: [
          '策略金庫上線',
          '跟單交易平台',
          'HyperEVM 多鏈',
          '治理框架',
        ],
      },
      q4: {
        title: '全面去中心化',
        items: [
          'ZhiSu Token 上線',
          'DAO 治理',
          'Layer 2 擴展',
          'AI 模型市場',
        ],
      },
    },
    riskLevels: {
      high: '高',
      low: '低',
      veryHigh: '極高',
      medium: '中',
    },
    footerLinks: {
      product: ['市場', 'AI 代理', '金庫', '排行榜', '費率'],
      developers: ['API 參考', 'SDK'],
      company: ['關於我們', '職缺', '新聞與媒體', '品牌指南', '聯絡我們'],
      legal: ['服務條款', '隱私權政策', 'Cookie 政策', '反洗錢政策', '風險揭露', '用戶協議'],
    },
    timeAgo: '{{time}}秒前',
  },
};